import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getClaimProcessingReport } from "../utils/API";
import Header from "../components/core/Header";
import CustomTable from "../components/core/CustomTable";
import {readStoredCount} from "../utils/handlers";
import { TablePagination } from "@mui/material";
import moment from "moment";
import tz from "moment-timezone";

const tableColumn = [
  {
    title: "Claim Id",
    field: "claimDataId",
  },

  {
    title: "Creation Date",
    field: "dateCreated",
    render: (rowData) =>
      rowData &&
      rowData.dateCreated && (
        <span>
          {" "}
          {moment(rowData.dateCreated)
            .tz("Asia/Kolkata")
            .format("DD- MM -YYYY, hh:mm:ss a")}{" "}
        </span>
      ),
  },
  {
    title: "Updated Date",
    field: "dateUpdated",
    render: (rowData) =>
      rowData &&
      rowData.dateUpdated && (
        <span>
          {" "}
          {moment(rowData.dateUpdated)
            .tz("Asia/Kolkata")
            .format("DD- MM -YYYY, hh:mm:ss a")}{" "}
        </span>
      ),
  },

  {
    title: "Status",
    field: "status",
    render: (rowData) =>
      rowData &&
      rowData.status && (
        <span>
          {rowData.status.includes("CLAIM_PROCESSED")
            ? "CLAIM PROCESSED"
            : rowData.status.includes("CLAIM_NOT_PROCESSED")
            ? "CLAIM_NOT_PROCESSED"
            : rowData.status}
        </span>
      ),
  },
  {
    title: "PML Result",
    field: "pmlProcessed",
  },
  {
    title: "Bill and Tariff Result",
    field: "billTariffProcessed",
  },
  {
    title: "vNeuron Result",
    field: "vneuronProcessed",
  },
];

function ClaimProcessingReport() {
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(0);
  useEffect(() => {
    fetchData();
  }, [pageSize, page]);
  const fetchData = async () => {
    let response = await getClaimProcessingReport(page, pageSize);

    setTableData(response.data);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Grid container>
      <Header />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          border: "1px solid",
          padding: 10,
          height: "1.5rem",
          marginLeft: 30,
          marginTop: 30,
          background: "#000",
          cursor: "pointer",
        }}
      >
        <div style={{ color: "#fff" }}>
          <ArrowBackIcon />
        </div>

        <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
          {" "}
          Go Back
        </Link>
      </div>
      <Grid
        item
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          width: "100vw",
        }}
      >
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          padding={3}
        >
          <Typography
            variant="body1"
            style={{
              marginBottom: "20px",
              fontSize: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Claim Processing Report
          </Typography>
        </Grid>
        <TablePagination
          rowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
          colSpan={3}
          count={readStoredCount("totalTableCount")}
          rowsPerPage={pageSize}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Claims per Page"
        />
        <CustomTable
          tableData={tableData}
          tableColumns={tableColumn}
          selection={false}
          noStickyHeader={true}
        />

        <TablePagination
          rowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
          colSpan={3}
          count={readStoredCount("totalTableCount")}
          rowsPerPage={pageSize}
          page={page}
          component="div"
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Claims per Page"
        />
      </Grid>
    </Grid>
  );
}

export default ClaimProcessingReport;
